import { useQuery } from '@apollo/client';
import * as Sentry from '@sentry/react';

import { isCourseraBadgeEnabled } from 'bundles/accomplishments/components/badge/utils/experimentUtils';
import VerifiedSkillsBadgeTemplateQuery from 'bundles/skills-common/shared/verified-skills/data/pathway-badge/VerifiedSkillsBadgeTemplateQuery.graphql';
import type {
  VerifiedSkillsBadgeTemplateQuery as QueryResult,
  VerifiedSkillsBadgeTemplateQueryVariables as QueryVariables,
} from 'bundles/skills-common/shared/verified-skills/data/pathway-badge/__generated__/VerifiedSkillsBadgeTemplateQuery';

const useGetBadgeTemplates = (isBadgeIssued: boolean) => {
  const { data, loading, error } = useQuery<QueryResult, QueryVariables>(VerifiedSkillsBadgeTemplateQuery, {
    context: {
      clientName: 'gatewayGql',
    },
    skip: !isCourseraBadgeEnabled() || !isBadgeIssued,
    fetchPolicy: 'network-only',
  });

  const is404Error = Boolean(error?.graphQLErrors?.some((err) => err.extensions?.code === 'NOT_FOUND'));

  if (error && !is404Error) {
    Sentry.captureException(error);
  }

  return { badgeTemplates: data?.LearnerProfile?.me?.badges, loading };
};

export default useGetBadgeTemplates;
